<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
        <div class="contact-block">
            <div :class="`container ${paddingOptions(data.paddingModifications)}`">
                <div class="row">
                    <div class="col-lg-6">
                        <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                            <h2 class="title" v-if="data.title">
                                <font-awesome class="icon-info fa-fw" :icon="data.icon" v-if="data.icon" />
                                {{ data.title }}
                            </h2>
                        </SmartLinkStandaloneElement>
                        <SmartLinkStandaloneElement :codename="typ.elements.sub_title.codename">
                            <h3 class="subtitle" v-if="data.subTitle">
                                {{ data.subTitle }}
                            </h3>
                        </SmartLinkStandaloneElement>
                        <SmartLinkStandaloneElement :codename="typ.elements.content.codename">
                            <span class="content" v-if="data.content">
                                <RichText :value="data.content" />
                            </span>
                        </SmartLinkStandaloneElement>
                    </div>
                    <div class="col-lg-6">
                        <SmartLinkStandaloneElement :codename="typ.elements.contact_list_title.codename">
                            <h2 class="title" v-if="data.contactListTitle">
                                {{ data.contactListTitle }}
                            </h2>
                        </SmartLinkStandaloneElement>
                        <SmartLinkStandaloneElement :codename="typ.elements.contact_item.codename">
                            <ul class="contact-list" v-if="data.contactItem && data.contactItem.length > 0">
                                <!-- Contact Item -->
                                <LinkedItemComponent v-for="cItem in data.contactItem" :model="cItem"
                                    :fromFooter="true" />
                            </ul>
                        </SmartLinkStandaloneElement>
                    </div>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { IContentItem, IContentItemElements } from '@kontent-ai/delivery-sdk';
import type { ContactBlockModel } from '~/models';
import { contentTypes } from '~/models';
import { paddingOptions } from '~/utils/styling-options'

const typ = contentTypes.contact_block;

const props = defineProps<{ model: ContactBlockModel, useSiteStore?: boolean, homePageId?: string }>();

const pageStore = usePageStore()
const homepageStore = useHomePageStore()
const siteStore = useSiteStore()

let contactItem: IContentItem<IContentItemElements>[] = []

if (props.homePageId) {
    contactItem = homepageStore.getListAs<IContentItem>(props.model.elements.contactItem.value)
} else {
    contactItem = props.useSiteStore 
        ? siteStore.getListAs<IContentItem>(props.model.elements.contactItem.value)
        : pageStore.getListAs<IContentItem>(props.model.elements.contactItem.value)
}

const data = {
    title: props.model.elements.title.value,
    subTitle: props.model.elements.subTitle.value,
    content: props.model.elements.content.value,
    icon: firstOrDefault(props.model.elements.icon.value),
    contactListTitle: props.model.elements.contactListTitle.value,
    contactItem: contactItem,
    paddingModifications: props.model.elements.paddingModificationsPaddingModifications.value.map((item) => item.codename),
}
</script>
